import { staticComponentValueConverter } from '../StaticComponentValues';
import { useSelector } from 'react-redux';
function Cart_2({ item }) {
  const customization = staticComponentValueConverter(item?.customization);
  const staticValues = useSelector(state => state.themeSlice?.staticValues);
  const products = useSelector(state => state.themeSlice.products);
  const firstProduct = products && Object.values(products)?.[0];

  console.log(firstProduct);

  return (
    <>
      <div className="w-full h-full relative flex flex-col">
        <div
          style={{
            display: 'flex',
            gap: staticValues[5],
            margin: staticValues[10],
            borderRadius: 10,
            borderWidth: 0.5,
            borderStyle: 'solid',
            borderColor: 'var(--secondaryThemeColor)',
            color: 'var(--secondaryThemeColor)',
          }}
        >
          <div style={{ display: 'flex' }}>
            <div>
              <img
                style={{
                  width: 110,
                  height: '100%',
                  borderTopLeftRadius: 10,
                  borderBottomLeftRadius: 10,

                  objectFit: customization?.backgroundSize,
                }}
                src={firstProduct?.image}
              />
            </div>
          </div>
          <div
            style={{
              display: 'flex',
              flexDirection: 'column',
              flex: 1,
              paddingTop: staticValues[10],
              paddingBottom: staticValues[10],
              paddingLeft: staticValues[5],
              paddingRight: staticValues[5],
            }}
          >
            <div style={{ textAlign: 'start', display: 'flex', flexDirection: 'column', gap: 5, flex: 1 }}>
              <div style={{ fontSize: 16, fontWeight: 'bold' }}>{firstProduct?.label}</div>
              <div style={{ fontSize: staticValues[10] }}>Adet: 1</div>

              {firstProduct?.data?.productVariantTypes?.map((variantType, index) => (
                <div key={index} style={{ color: 'var(--secondaryThemeColor)', fontSize: staticValues[10] }}>
                  {variantType?.variantType?.name}: {variantType?.variantType?.values?.[0]?.name}
                </div>
              ))}
            </div>

            <div style={{ display: 'flex', flexDirection: 'column', gap: 5, alignItems: 'start' }}>
              <div style={{ display: 'flex', gap: 5, alignItems: 'center' }}>
                <div style={{ fontSize: staticValues[10], textDecoration: 'line-through' }}>
                  ₺{(firstProduct?.data?.variants?.[0]?.prices[0]?.sellPrice * 1.01)?.toFixed(2)}
                </div>
                <div style={{ fontSize: staticValues[10], fontWeight: 'bold' }}>
                  ₺{(firstProduct?.data?.variants?.[0]?.prices[0]?.sellPrice * 0.9)?.toFixed(2)}
                </div>
              </div>
              <div
                style={{
                  width: '100%',
                  display: 'flex',
                  flexDirection: 'row',
                  justifyContent: 'space-between',
                  alignItems: 'center',
                }}
              >
                <div
                  style={{
                    display: 'flex',
                    alignItems: 'center',
                    border: '1px solid black',
                    borderRadius: 5,
                    fontSize: staticValues[10],
                    backgroundColor: 'var(--thirdThemeColor)',
                  }}
                >
                  <div
                    style={{
                      padding: '0px 10px',
                      borderRadius: 5,
                      height: 30,
                      fontWeight: 600,
                      display: 'flex',
                      alignItems: 'center',
                      backgroundColor: 'var(--thirdThemeColor)',
                      color: 'var(--fourthThemeColor)',
                    }}
                  >
                    -
                  </div>
                  <div
                    style={{
                      padding: '0px 10px',
                      borderRadius: 5,
                      height: 30,
                      fontWeight: 600,
                      display: 'flex',
                      alignItems: 'center',
                      backgroundColor: 'var(--thirdThemeColor)',
                      color: 'var(--fourthThemeColor)',
                    }}
                  >
                    1
                  </div>
                  <div
                    style={{
                      padding: '0px 10px',
                      borderRadius: 5,
                      height: 30,
                      fontWeight: 600,
                      display: 'flex',
                      alignItems: 'center',
                      backgroundColor: 'var(--thirdThemeColor)',
                      color: 'var(--fourthThemeColor)',
                    }}
                  >
                    +
                  </div>
                </div>
                <div style={{ color: 'red', paddingRight: 5 }}>Delete</div>
              </div>
            </div>
          </div>
        </div>
        {/* <div
          className="mt-auto flex flex-row  justify-between items-center  p-[20px] shadow-2xl"
          style={{
            borderTopWidth: 0.5,
            borderTopColor: 'var(--secondaryThemeColor)',
            borderTopStyle: 'solid',
          }}
        >
          <div className="w-[45%]">
            <div
              className="text-left text-[14px]"
              style={{
                color: 'var(--secondaryThemeColor)',
              }}
            >
              Total Amount
            </div>
            <div
              className="text-left text-[14px]"
              style={{
                fontSize: staticValues[12],
                textDecoration: 'line-through',
                color: 'var(--secondaryThemeColor)',
              }}
            >
              ₺{(firstProduct?.data?.variants?.[0]?.prices[0]?.sellPrice * 1.01)?.toFixed(2)}
            </div>
            <div
              className="text-left text-[14px]"
              style={{ fontSize: staticValues[12], fontWeight: 'bold', color: 'var(--secondaryThemeColor)' }}
            >
              ₺{(firstProduct?.data?.variants?.[0]?.prices[0]?.sellPrice * 0.9)?.toFixed(2)}
            </div>
          </div>
          <div
            className="w-[55%] p-[12px] bg-[#7059EF] text-white rounded-[5px] flex-1"
            style={{
              color: customization?.buttonTextColor,
              backgroundColor: customization?.buttonBackgroundColor,
            }}
          >
            Sipariş Ver
          </div>
        </div> */}
      </div>
    </>
  );
}

export default Cart_2;
